export default "<div class=\"spinner-wrapper\">\n    <p-progressSpinner></p-progressSpinner>\n</div>";